import { Component, Input } from '@angular/core';
import { StateService, TransitionService } from '@uirouter/core';
import { FoldersApiService } from 'src/app/api/services/folders-api.service';
import { DisplayService } from 'src/app/displays/services/display.service';
import { ScheduleService } from 'src/app/schedules/services/schedule.service';
import { TemplateEditorService } from 'src/app/template-editor/services/template-editor.service';
import {
  RouteMetadata,
  RouteMetadataService,
} from '../../services/route-metadata.service';

@Component({
  selector: 'page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
  standalone: false,
})
export class PageTitleComponent {
  @Input() iconOnly = false;

  routeMetadata: RouteMetadata;

  constructor(
    private transitionService: TransitionService,
    private routeMetadataService: RouteMetadataService,
    private stateService: StateService,
    private templateEditorService: TemplateEditorService,
    private scheduleService: ScheduleService,
    private displayService: DisplayService,
  ) {
    this.transitionService.onSuccess({}, () => {
      this.updateTitle();
    });

    this.updateTitle();
  }

  isBackDisabled(): boolean {
    if (this.routeMetadata?.backLink === 'apps.editor.list') {
      return (
        this.templateEditorService.savingPresentation ||
        this.templateEditorService.isUnsaved()
      );
    }
    return false;
  }

  goBack(): void {
    if (!this.routeMetadata?.backLink || this.isBackDisabled()) return;

    let folderId: string | null = null;

    if (
      this.routeMetadata.backLink === 'apps.editor.list' &&
      this.templateEditorService.presentation?.id
    ) {
      folderId = this.templateEditorService.presentation.folderId || null;
    } else if (
      this.routeMetadata.backLink === 'apps.schedules.list' &&
      this.scheduleService.schedule?.id
    ) {
      folderId = this.scheduleService.schedule.folderId || null;
    } else if (
      this.routeMetadata.backLink === 'apps.displays.list' &&
      this.displayService.display?.id
    ) {
      folderId = this.displayService.display.folderId || null;
    }

    this.stateService.go(this.routeMetadata.backLink, {
      folderId: folderId === FoldersApiService.ROOT_FOLDER_ID ? null : folderId,
    });
  }

  private updateTitle(): void {
    this.routeMetadata = this.routeMetadataService.getActiveRouteMetadata();
  }
}
